
import { defineComponent, computed, PropType } from 'vue'
import { useInvoicesModule, InvoiceItem, Invoice, InvoiceStatus } from '@/modules/invoices'
import { DeliveryPolicyType } from '@/modules/billing-templates'
import RevokeInvoice from '@/components/invoices/forms/revoke-invoice.vue'

export default defineComponent({
    name: 'invoices-show-invoice',
    components: { RevokeInvoice },
    props: {
        invoice: {
            type: Object as PropType<Invoice>,
            required: true
        },
        updateCallback: {
            type: Function as PropType<() => void>,
            required: true
        },
        previewMode: {
            type: Boolean,
            required: false
        }
    },
    setup (props) {
        const { getFormattedPrice, getFormattedDate } = useInvoicesModule()

        const currency = computed(() => props.invoice.payment.currency)

        const productColumns = ([
            { name: 'description', label: 'Description', field: 'description', align: 'left' },
            { name: 'quantity', label: 'Amount', field: 'quantity', align: 'left' },
            { name: 'netPrice', label: 'Price excl. VAT', field: (row: InvoiceItem) => getFormattedPrice(row.netPrice, currency.value), align: 'left' },
            { name: 'taxPercentage', label: 'VAT', field: (row: InvoiceItem) => row.taxPercentage + ' %', align: 'left' }
        ])

        const totalExcludingVat = computed(() => getFormattedPrice(props.invoice.payment.totalNet, currency.value))
        const totalIncludingVat = computed(() => getFormattedPrice(props.invoice.payment.totalGross, currency.value))
        const formattedCreatedAtDate = computed(() => getFormattedDate(props.invoice.createdAt.date))
        const formattedDueDate = computed(() => getFormattedDate(props.invoice.payment.dueDate.date))

        const invoiceBusinessInfo = [
            { label: 'Invoice date', value: props.previewMode ? '-' : formattedCreatedAtDate.value },
            { label: 'Business ID', value: props.invoice.customer.businessId },
            { label: 'Vat ID', value: props.invoice.customer.vatId },
            { label: 'Customer number', value: props.invoice.customer.customerNumber },
            { label: 'Terms of payment', value: props.invoice.payment.termsOfPayment + ' days' },
            { label: 'Penalty percent', value: props.invoice.payment.penaltyPercentage + '%' },
            { label: 'Due date', value: props.previewMode ? '-' : formattedDueDate.value },
            { label: 'Currency', value: props.invoice.payment.currency },
            { label: 'Billing reference', value: props.invoice.billing.reference }
        ]

        const invoiceDeliveryAddress = [
            { label: 'Street', value: props.invoice.delivery.policy.street },
            { label: 'Zip', value: props.invoice.delivery.policy.zip },
            { label: 'City', value: props.invoice.delivery.policy.city }
        ]

        const invoiceDeliveryOperator = [
            { label: 'Operator', value: props.invoice.delivery.policy.operator },
            { label: 'Address', value: props.invoice.delivery.policy.address }
        ]

        const invoiceTotalPayment = [
            { label: 'Total excl. VAT', value: totalExcludingVat.value },
            { label: 'Total incl. VAT', value: totalIncludingVat.value }
        ]
        const invoiceDescription = computed(() => props.invoice.description)

        return {
            productColumns,
            DeliveryPolicyType,
            totalExcludingVat,
            totalIncludingVat,
            formattedCreatedAtDate,
            formattedDueDate,
            invoiceBusinessInfo,
            invoiceDeliveryAddress,
            invoiceDeliveryOperator,
            invoiceTotalPayment,
            InvoiceStatus,
            invoiceDescription
        }
    }
})
